export const keepBlockSelectionAttribute = 'data-keep-block-selection'

const floatingLayerSelectors = ['.MuiPopover-root', '.MuiPickersPopper-root']

export const blockSelectionSelector = [
  `.react-grid-item`,
  `[${keepBlockSelectionAttribute}]`,
  ...floatingLayerSelectors,
].join(', ')

export const blockErrorTypes = {
  required: 'required',
  atLeastOne: 'atLeastOne',
}

export const missingDataTypes = {
  scenarioItems: 'scenarioItems',
  scenarioShipments: 'scenarioShipments',
  scenarioReturnRequests: 'scenarioReturnRequests',
  realOrderItems: 'realOrderItems',
  realOrderShipments: 'realOrderShipments',
}

export const notActiveOnTypes = {
  previewDate: 'previewDate',
  today: 'today',
}
